import React from 'react';
import { HomePageCarouselState } from 'src/domains/layouts/state/cmsState/homePageCarouselState/HomePageCarouselState';
import { observer } from 'src/utils/mobx-react';
import { ScrollLeft, ScrollRight, ChevronIcon } from './HomePageCarouselPromos.style';

interface PropsTypes {
    state: HomePageCarouselState;
}

export const ChevronsWrapper = observer('ChevronsWrapper', ({ state }: PropsTypes) => {
    const { dotsList, currentSlideGroupId, setNextSlide, setPreviousSlide } = state;
    const isActiveLeft = currentSlideGroupId > 0;
    const isActiveRight = currentSlideGroupId < dotsList.length - 1;

    return (
        <>
            {isActiveLeft ? (
                <ScrollLeft>
                    <ChevronIcon
                        position='left'
                        onClick={setPreviousSlide}
                    />
                </ScrollLeft>
            ) : null}
            {isActiveRight ? (
                <ScrollRight>
                    <ChevronIcon
                        position='right'
                        onClick={setNextSlide}
                    />
                </ScrollRight>
            ) : null}
        </>
    );
});
